export default "__VITE_ASSET__b467d83c__"